export class UserDiseaseHistoryModel {
  public userDiseaseHistoryId: number;
  public userId: number;
  public diseaseId: number;
  public diseaseCode: string;
  public diseaseName: string;
  public startDate?: string;
  public endDate?: string;
  public diseaseTypeId?: number;
  public comments: string;
  public prescriptionName: string;
  public isActive: boolean;
  public prescriptionDoctor: string;
  public prescriptionId: number;
}